// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WEiIZwVNYn_DzPG77umZ{font-weight:500;font-size:16px;line-height:18px;display:flex;align-items:center;color:#545556}`, "",{"version":3,"sources":["webpack://./ui-kit/Subtitle/Subtitle.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CACA,cAAA,CACA,gBAAA,CAEA,YAAA,CACA,kBAAA,CAEA,aAAA","sourcesContent":[".subtitle {\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  line-height: 18px;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  color: #545556;\r\n  // margin-bottom: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subtitle": `WEiIZwVNYn_DzPG77umZ`
};
export default ___CSS_LOADER_EXPORT___;
